<mat-toolbar class="tool-bar">
  <button mat-icon-button (click)="toggleMenu()" style="display: flex; align-items: center; justify-content: center;">
  <a href="navbar-brand" style="display: flex; align-items: center;">
    <img src="assets/dist/images/logo.png" 
         style="border-radius: 50%; height: 40px; width: 40px;"
         alt="some image">
  </a>
</button>

  <span class="app-title">Yard Hostle</span>
  <span class="title-button-space"></span>
  <ng-container *ngIf="loggedIn()">

    <section class="button-container">
      <button mat-icon-button routerLink="/" matTooltip="Home" aria-label="Navigate to the Home page">
        <mat-icon>home</mat-icon>
      </button>
      <button mat-icon-button routerLink="/yard-view" matTooltip="Yard View" aria-label="Navigate to the Yard View page">
        <mat-icon>view_list</mat-icon>
      </button>
    </section>

    <section class="button-container" *ngIf="isClerk()">
      <button mat-icon-button routerLink="/add-spot" matTooltip="Add Yard Spot" aria-label="Navigate to the Add Yard page">
        <mat-icon>add</mat-icon>
      </button>
    </section>

    <section class="button-container">
      <button mat-icon-button routerLink="/moves" matTooltip="Moves" aria-label="Navigate to the Moves page">
        <mat-icon>trending_flat</mat-icon>
      </button>
    </section>

    <section class="button-container" *ngIf="isClerk()">
      <button
        mat-icon-button
        routerLink="/assign-moves"
        matTooltip="Assign Moves"
        aria-label="Navigate to the Assign Moves page"
      >
        <mat-icon>assignment</mat-icon>
      </button>
    </section>

    <section class="button-container">
      <button
        mat-icon-button
        routerLink="/moves-history"
        matTooltip="Moves History"
        aria-label="Navigate to the Moves History page"
    >
        <mat-icon>assignment_turned_in</mat-icon>
      </button>
    </section>

    <section class="button-container">
      <button mat-icon-button routerLink="/trailers" matTooltip="Trailers" aria-label="Navigate to the Trailers page">
        <mat-icon>local_shipping</mat-icon>
      </button>
    </section>

    <section class="button-container" *ngIf="isAdmin()">
      <button
        mat-icon-button
        routerLink="/instance-management"
        matTooltip="Instance selection"
        aria-label="Navigate to the Yard View page"
    >
      <mat-icon>group_add</mat-icon>
    </button>

    </section>
    <button mat-icon-button matTooltip="Logout" (click)="logOut()" aria-label="Logout">
      <mat-icon>logout</mat-icon>
    </button>
  </ng-container>
  <ng-container *ngIf="!loggedIn()">

    <button mat-icon-button
      matTooltip="Home" 
      routerLink="/" 
      aria-label="Navigate to the Home page">
      <mat-icon>home</mat-icon>
    </button>

    <button 
      mat-icon-button
      matTooltip="Pricing" 
      routerLink="/pricing" 
      aria-label="Navigate to the Pricing page">
      <mat-icon>paid</mat-icon>
    </button>

    <button
      mat-icon-button
      matTooltip="Forgot password"
      routerLink="/forgot-password"
      aria-label="Navigate to the Reset Password page"
    >
      <mat-icon>lock_reset</mat-icon>
    </button>
    <button 
      mat-icon-button 
      matTooltip="Login"
      aria-label="Navigate to login page" (click)="openLoginDialog()">
      <mat-icon>login</mat-icon>
    </button>
  </ng-container>
</mat-toolbar>
